import React, { useState, useEffect, useRef } from 'react';

const ImageLazyLoader = ({ 
  src, 
  alt, 
  className = '', 
  placeholder = '/api/placeholder.png',
  onLoad = () => {},
  onError = () => {},
  style = {},
  onClick = () => {},
  ...otherProps
}) => {
  const [imageSrc, setImageSrc] = useState(placeholder);
  const [imageRef, setImageRef] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    let observer;
    
    if (imageRef && !isLoaded) {
      if (IntersectionObserver) {
        observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                // Load the real image when it comes into view
                const img = new Image();
                img.src = src;
                img.onload = () => {
                  setImageSrc(src);
                  setIsLoaded(true);
                  onLoad();
                };
                img.onerror = () => {
                  setIsError(true);
                  onError();
                };
                
                // Stop observing once loaded
                if (observer && imageRef) {
                  observer.unobserve(imageRef);
                }
              }
            });
          },
          {
            threshold: 0.01,
            rootMargin: '50px' // Start loading 50px before visible
          }
        );
        observer.observe(imageRef);
      } else {
        // Fallback for older browsers
        setImageSrc(src);
        setIsLoaded(true);
      }
    }

    return () => {
      if (observer && imageRef) {
        observer.unobserve(imageRef);
      }
    };
  }, [imageRef, src, isLoaded, onLoad, onError]);

  return (
    <img
      ref={setImageRef}
      src={imageSrc}
      alt={alt}
      className={`${className} ${isLoaded ? 'loaded' : 'loading'}`}
      style={{
        transition: 'opacity 0.3s',
        opacity: isLoaded ? 1 : 0.8,
        ...style
      }}
      onClick={onClick}
      {...otherProps}
    />
  );
};

export default ImageLazyLoader;